import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { QuoteProductListService } from './core/quote-product-list.service';
import { I18nModule } from '@spartacus/core';
import { QuoteSearchProductService } from '../_core/search-products.service';
import { CustomPaginationModule } from '../../../../misc/pagination/pagination.module';
import { LocalLoaderComponent } from '../../../../../../components/loader/local-loader/local-loader.component';
import { ProductListItemComponent } from './product-list-item/product-list-item.component';
import { SEARCH_TYPE } from '../../../core/quotes.model';

@Component({
  selector: 'product-list',
  standalone: true,
  imports: [CommonModule, ProductListItemComponent, CustomPaginationModule, LocalLoaderComponent, I18nModule],
  templateUrl: './product-list.component.html',
  styleUrl: './product-list.component.scss',
})
export class ProductListComponent {
  SEARCH_TYPE = SEARCH_TYPE;
  isPristine = true;
  searchItems$ = this.quoteProductListService.getSearchResult();
  showProducts$ = this.quoteProductListService.showProducts$;
  @Output() _onChangeSearchType = new EventEmitter<SEARCH_TYPE>();

  constructor(
    private quoteProductListService: QuoteProductListService,
    private quoteSearchProductService: QuoteSearchProductService,
  ) {}

  handlerPage(page: number) {
    this.quoteSearchProductService.page$.next(page);
  }

  handleChangeSearchType(type: SEARCH_TYPE) {
    this._onChangeSearchType.emit(type);
  }
}
